<div class="recorder-component">
  <button
    type="button"
    class="btn btn-primary"
    *ngIf="!isRecording && !blobUrl"
    (click)="startRecording()"
  >
    <img src="./assets/icon/microphone.svg" />
  </button>


  <div class="recorded-time" *ngIf="isRecording && !blobUrl">
    <h3>{{ recordedTime }}</h3>
  </div>

  <!--<div>
    <audio *ngIf="!isRecording && blobUrl" controls>
      <source [src]="blobUrl" type="audio/webm" />
    </audio>
  </div>-->
</div>
